import React from "react";
import { OrbitComponent } from "../base-components/orbit-component/orbit-component";
import { UserData } from "../../services/sdk/sdk.service.interface";
import { Check } from "@sparkware/app-utils";
import {observer} from "mobx-react";

export interface UserInfoComponentProps {
    className?: string;
    useSpanWrapper?: boolean;
    selectedUserInfo: keyof UserData;
}

@observer
export class UserInfo extends OrbitComponent<UserInfoComponentProps> {
    render() {
        let shownData = this.services.user.userData[this.props.selectedUserInfo];
        if (Check.isNullOrUndefined(shownData)) {
            return null;
        }
        if (this.props.useSpanWrapper || this.props.className) {
            return <span className={this.props.className}>
                {shownData}
            </span>;
        } else {
            return shownData;
        }
    }
}
